export const API_URL = import.meta.env[
  "VITE_REACT_APP_DOMAIN_API_URL"
] as string;
export const JWT_SECRET = "123456" as string;
export const PASSWORD_SET_PAGE_URL = (import.meta.env[
  "VITE_REACT_APP_AUTH_APP_URL"
] + "/account/setPassword") as string;
export const LOGIN_PAGE_URL = (import.meta.env["VITE_REACT_APP_AUTH_APP_URL"] +
  "/login") as string;
export const MY_APP_URL = import.meta.env[
  "VITE_REACT_APP_SCAN_APP_URL"
] as string;
export const PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]{8,128}$/;
